import React, { ReactNode } from 'react';
import { Box } from '@clariness/clarikit-react';
import { NavBarActionLink, NavBarDivider, NavBarLink } from './components';

type NavBarProps = {
  children: ReactNode;
};

export const NavBar = ({ children }: NavBarProps) => {
  return (
    <Box
      as="nav"
      display="flex"
      alignItems="center"
      gap={{ _: '12px', md: '15px' }}
    >
      {children}
    </Box>
  );
};

NavBar.ActionLink = NavBarActionLink;
NavBar.Link = NavBarLink;
NavBar.Divider = NavBarDivider;
